import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  list: [],
  mainList: [],
  pageInfo: { page: 1, totalPage: 2 },
  mainPageInfo: { page: 1, totalPage: 2 },
  detail: {
    // productCategoryNo: null,
    storeNo: null,
    categoryKr: '',
    categoryVn: '',
    categoryEn: '',
    file:null,
    rawFile:null
    // regDate: '',
    // isActive: ''
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
